import { render, staticRenderFns } from "./Databases.vue?vue&type=template&id=42182e93&scoped=true"
import script from "./Databases.vue?vue&type=script&lang=js"
export * from "./Databases.vue?vue&type=script&lang=js"
import style0 from "./Databases.vue?vue&type=style&index=0&id=42182e93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42182e93",
  null
  
)

export default component.exports